/**
 * 客訂／銷貨產品列折扣率轉換。
 *
 * 畫面「折數」是成交價倍率（`0.9`＝九折、`1`＝無折扣）；
 * 後端 `discount_rate` 自 be doc `4ee43f3d` 起是折抵比例（`0.1`＝折抵 10%、`0`＝無折扣）。
 * 兩者互為 `1 - x`；只在讀寫 API 的邊界轉換。
 */
const SCALE = 1e6;

function flip(value) {
  if (value === '' || value == null) {
    return null;
  }
  const n = Number(value);
  if (!Number.isFinite(n)) {
    return null;
  }
  // 1 - 0.9 會得到 0.09999999999999998，取到小數第 6 位
  return Math.round((1 - n) * SCALE) / SCALE;
}

/** 畫面折數（價格倍率）→ API `discount_rate`（折抵比例）；空白或非數字回 null。 */
export function discountMultiplierToApiRate(multiplier) {
  return flip(multiplier);
}

/** API `discount_rate`（折抵比例）→ 畫面折數（價格倍率）；null／空白回 null。 */
export function apiDiscountRateToMultiplier(rate) {
  return flip(rate);
}
